import { initContract } from "@ts-rest/core";
import z from "zod";

import {
  consentDocumentSignaturesSchema,
  consentDocumentTypeEnumSchema,
  initialsCoordinatesSchema,
  pcNameCoordinatesSchema,
  signatureBoxCoordinatesSchema,
} from "@libs/db-schemas";

import { HTTPStatusCode } from "../../types.ts";
import { errorSchema } from "../../utils/errors.ts";

const c = initContract();

export const consentDocumentsContract = c.router({
  listConsentDocuments: {
    path: "/consent-documents",
    summary: "List the appropriate consent documents for the user",
    method: "GET",
    responses: {
      [HTTPStatusCode.OK]: z.array(
        z.object({
          consentDocumentId: z.uuid(),
          type: consentDocumentTypeEnumSchema,
          consentDocumentUri: z.url(),
          versionNumber: z.number(),
          language: z.string(),
          signatureDataUri: z.string().optional(),
          signedAt: z.string().optional(),
        }),
      ),
      [HTTPStatusCode.NOT_FOUND]: errorSchema,
    },
  },
  addSignature: {
    path: "/consent-documents/signatures",
    summary: "Add a signature to multiple consent documents",
    method: "POST",
    body: z.object({
      consentDocumentIds: z.array(z.uuid()).min(1),
      signatureDataUri: z.string(),
    }),
    responses: {
      [HTTPStatusCode.CREATED]: z.array(consentDocumentSignaturesSchema),
      [HTTPStatusCode.BAD_REQUEST]: errorSchema,
      [HTTPStatusCode.NOT_FOUND]: errorSchema,
    },
  },

  getSignedConsentDocuments: {
    path: "/consent-documents/signed",
    summary: "Get all signed consent documents for the user",
    method: "GET",
    responses: {
      [HTTPStatusCode.OK]: z.array(
        z.object({
          id: z.uuid(),
          type: consentDocumentTypeEnumSchema,
          downloadUrl: z.url(),
          signatureUri: z.string(),
          signatureBoxCoordinates: signatureBoxCoordinatesSchema.nullish(),
          pcSignatureBoxCoordinates: signatureBoxCoordinatesSchema.nullish(),
          pcNameCoordinates: pcNameCoordinatesSchema.nullish(),
          patientInitialsCoordinates: initialsCoordinatesSchema.nullish(),
          firstName: z.string().nullish(),
          lastName: z.string().nullish(),
          representativeFirstName: z.string().nullish(),
          representativeMiddleName: z.string().nullish(),
          representativeLastName: z.string().nullish(),
          representativeSignatureDataUri: z.string().nullish(),
        }),
      ),
      [HTTPStatusCode.NOT_FOUND]: errorSchema,
    },
  },
});
